export class ArgumentOutOfRangeError extends Error {
    public constructor(inName: string, methodName: string, paramName: string) {
        super(`${inName}:${methodName}:Argument out of range ${paramName}`);
    }
}
